import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router';
import "./XSifterApp.css"
import XSifterExternalPage from './components/common/XSIfterExternalPage';
import XSifterAppPage from './components/common/XSifterAppPage';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import NewVersionNotice from './components/common/NewVersionNotice';

export default class XSifterApp extends React.Component {
    render() {

        return (
            <React.StrictMode>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/app/*" element={<XSifterAppPage />} />
                            <Route path="*" element={<XSifterExternalPage />} />
                        </Routes>
                    </BrowserRouter>
                    <NewVersionNotice />
                </LocalizationProvider>
            </React.StrictMode>
        )
    }
}